<div class="confirm-cont"  nbSpinnerStatus="success">
    <div class="head">
        <span>{{message}}</span>
    </div>
    <div class="cont">
        <button nbButton (click)="cancel()">Cancel</button>
        <button nbButton (click)="Action(tasktype, data)">Confirm</button>
    </div>
</div>